import React from 'react'
import '../styles/shared/common.scss'

export function useBoldText (text: string): React.ReactNode {
  const parts = text.split(/{bold}(.*?){\/bold}/)
  if (parts.length === 1) return text
  return parts.map((part, i) =>
    i % 2 === 1 ? <span key={i} className="bold">{part}</span> : part
  )
}
